module.exports = __webpack_public_path__ + "media/images/performance-group-d6d8c1e61331bc73a12a397bb276348c.png";